module.exports = __webpack_public_path__ + "static/link-db853b6640410201a1e57071fc4d2818.png";